/**
 * Códigos PIX copia-e-cola dentro do TEXTO da resposta do Vision.
 *
 * O card `VisionPixCard` cobre o PIX que vem estruturado no tool_result. Este
 * módulo cobre o caso em que o LLM despeja o código inteiro no markdown (uma
 * listagem com 8 títulos virava 8 blocos de 140 caracteres ilegíveis num
 * painel de 320px). É determinístico — não depende de o prompt ser obedecido.
 *
 * Fluxo: `extractPixCodes` troca cada código por um marcador alfanumérico ANTES
 * do markdown (senão o linkify partiria o código no `sicredi.com.br`);
 * `injectPixChips` troca o marcador, já no HTML, por um botão curto que copia
 * o código inteiro (delegação de clique em quem renderiza).
 */

// BR Code EMV: começa em 000201 e termina no CRC16 (6304 + 4 hex).
const PIX_RE = /000201[0-9A-Za-z.\-/*:_+@]{20,}?6304[0-9A-Fa-f]{4}/g;
const MARKER = 'PIXCODE7X';
const MARKER_RE = /(<code>)?PIXCODE7X(\d+)Z(<\/code>)?/g;

export const PIX_CHIP_ATTR = 'data-pix-index';

export const extractPixCodes = content => {
  const codes = [];
  const text = String(content || '').replace(PIX_RE, code => {
    codes.push(code);
    return `${MARKER}${codes.length - 1}Z`;
  });
  return { content: text, codes };
};

export const pixTail = code => code.slice(-4).toUpperCase();

export const injectPixChips = (html, codes, label) =>
  String(html || '').replace(MARKER_RE, (_, __, index) => {
    const code = codes[Number(index)];
    if (!code) return '';
    return (
      `<button type="button" ${PIX_CHIP_ATTR}="${index}" ` +
      'class="inline-flex items-center gap-1 align-baseline rounded-md border border-n-weak bg-n-alpha-2 px-1.5 py-0.5 font-mono text-xs text-n-slate-12 hover:bg-n-alpha-3 focus-visible:outline focus-visible:outline-1 focus-visible:outline-n-brand-ink">' +
      `${label(pixTail(code))}</button>`
    );
  });
